function isJSONParseResult(v) {
    return v === null || typeof v === 'number' || typeof v === 'string' || typeof v === 'boolean' || typeof v === 'object';
}
export function parseJSON(str, type_in_error_message) {
    try {
        const res = JSON.parse(str);
        if (isJSONParseResult(res)) {
            return res;
        }
        else {
            console.error('Parsing ' + type_in_error_message + ' failed and returned undefined on input string: ', str);
            return undefined;
        }
    }
    catch (exception) {
        if (exception instanceof SyntaxError) {
            console.error('Parsing ' + type_in_error_message + ' failed with error ' + exception.message + ' on input string: ', str);
        }
        return undefined;
    }
}
